/* eslint-disable max-len */
import { FunctionComponent as F } from 'react';
import Stack from '@mui/material/Stack';
import Subtitle from '../../components/UI/Text/Subtitle';
import ArticleText from '../../components/UI/Text/ArticleText';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';


const Fonts: F = () =>
{
  return (
    <Container>
      <Stack spacing={2}>

        <Subtitle>Blogger Sans</Subtitle>
        <ArticleText>
          Use in Protoplan logo.
          <br/>
          © 2014 Sergiy S. Tkachenko / 4th February© 2014
          <br/>
          <Link
            underline='none'
            href='https://creativecommons.org/licenses/by-nd/4.0/'>
            https://creativecommons.org/licenses/by-nd/4.0/
          </Link>
        </ArticleText>

      </Stack>
    </Container>

  );
};

export default Fonts;
